import { FormInstance } from "antd";
import { useEffect, useState } from "react";
import { IntegrationFormData, IntegrationProtocol } from "../../../api";
import { EmailFormItems } from "./EmailFormItems";
import { FormWrapper } from "./FormWrapper";
import { TriggerEventsFormItem } from "./TriggerEventsFormItem";
interface EmailFormProps {
  updatedProtocol: IntegrationProtocol;
  form: FormInstance<IntegrationFormData>;
  formData: IntegrationFormData;
  integrationDataLoading: boolean;
  setProtocolChanged: (newProtocol: IntegrationProtocol) => void;
}

export function EmailForm({
  updatedProtocol,
  form,
  formData,
  integrationDataLoading,
  setProtocolChanged,
}: EmailFormProps) {
  const [isFormValid, setIsFormValid] = useState(true);

  const [prevFormDataString, setPrevFormDataString] = useState<string>("");

  useEffect(() => {
    if (formData && !integrationDataLoading) {
      const currentFormDataString = JSON.stringify(formData);

      // Only update form if data has actually changed to prevent form reverting back to initial values
      if (prevFormDataString !== currentFormDataString) {
        setPrevFormDataString(currentFormDataString);
        form.setFieldsValue({
          endpointUrl: formData.endpointUrl,
          integrationName: formData.integrationName,
          integrationProtocol: updatedProtocol,
          events: formData.events || [],
        });
      }
    }
  }, [formData]);

  return (
    <FormWrapper
      form={form}
      loading={integrationDataLoading}
      setFormDataReady={setIsFormValid}
      setProtocolChanged={setProtocolChanged}
    >
      <EmailFormItems formDisabled={integrationDataLoading} />
      <TriggerEventsFormItem formDisabled={integrationDataLoading} />
    </FormWrapper>
  );
}
